import { create } from "zustand"

type SignupStore = {
  open: boolean
  value: string
  setOpen(data: boolean): void
  setValue(data: string): void
}

export const useSignup = create<SignupStore>((set, get) => ({
  open: false,
  setOpen: (data) => set({ open: data }),
  value: "",
  setValue: (data) => set({ value: data }),
}))
